export default {
  state: {
    // new account form -------------------------------------------
    newAccountForm: {
      citizenshipCountry: '',
      dateOfBirth: '',
      socialSecurityNumber: '',
      contactDetails: {
        givenName: '',
        familyName: '',
        phone: [
          {
            phoneType: '',
            phoneNumber: '',
          },
        ],
        email: [''],
      },
      // for entity business is home address,
      // bussienss telephone number is phone number
      // authorized signer name is contact details given name and family name
      // foreign is the same except birth country citizenship country foreign taxidnumber and taxidcountry
      // custodian is same except two fields

      // suitability profile and investment profile - entity personal trust, foreign, IRA, new account, entity
      homeAddress: {
        city: '',
        country: '',
        postal: '',
        state: '',
        streets: [''],
      },
      mailingAddress: {
        city: '',
        country: '',
        postal: '',
        state: '',
        streets: [''],
      },
      employment: {
        //IRA, new account, foreign
        employmentStatus: '',
        employerName: '',
        position: '',
        yearsEmployed: '',
        businessAddress: {
          city: '',
          country: '',
          postal: '',
          state: '',
          streets: [''],
        },
      },
      investmentProfile: {
        riskStandardOptions: '',
        uncoveredOptionWriters: '',
        investmentExperience: '',
        riskTolerance: '',
        investmentObjective: '',
        minTotalNetWorthUSD: '',
        minAnnualIncomeUSD: '',
        minLiquidNetWorthUSD: '',
        maxTotalNetWorthUSD: '',
        maxAnnualIncomeUSD: '',
        maxLiquidNetWorthUSD: '',
        timeHorizon: '',
        liquidityNeeds: '',
        stockTradesPerYear: '',
        optionsTradesPerYear: '',
        commonditiesTradesPerYear: '',
        corporateBondsTradesPerYear: '',
        municipalBondsTradesPerYear: '',
        governmentBondsTradesPerYear: '',
        fundsTradesPerYear: '',
        marginAccountTradesPerYear: '',
        optionDisclosureDeliveryDate: '',
        priorInvestmentExperiences: {
          firmName: '',
          numberOfYears: '',
          stillOpen: '',
          estimatedValueUSD: '',
        },
      },
    },
    // Individual -------------------------------------------
    individualFormValues: {
      citizenshipCountry: 'USA',
      homeCountry: 'USA',
    },
    employmentInfoFormValues: {
      employmentStatus: '',
      employer: '',
      position: '',
      yearsEmployed: '',
      employerStreet: '',
      employerCity: '',
      employerState: '',
      employerCountry: '',
      employerPostal: '',
    },
    financialProfileFormValues: {
      investmentExperienceSelected: '',
      liquidityNeedsSelected: '',
      annualIncome: [],
      liquidNetWorth: [],
      totalNetWorth: [],
      riskToleranceSelected: '',
      investmentObjectiveSelected: '',
      timeHorizonSelected: '',
    },
    jointApplicantValues: {
      jointTenantsInCommonParticipants: [],
    },
    // Business -------------------------------------------
    entityFormValues: {},
    entityOfficersArray: [
      {
        name: '',
        citizenship: '',
        socialSecurityNumber: '',
        street: '',
        city: '',
        state: '',
        postalCode: '',
        country: '',
        dateOfBirth: null,
        activePicker: null,
        menu: false,
        idDocumentType: '',
        idNumber: '',
        idIssuedBy: '',
        idIssueDate: '',
        idExpirationDate: '',
        memberManager: '',
      },
    ],
    beneficialOwnersFormValues: [
      // {
      //   name: "",
      //   citizenship: "",
      //   socialSecurityNumber: "",
      //   street: "",
      //   city: "",
      //   state: "",
      //   postalCode: "",
      //   country: "",
      //   dateOfBirth: null,
      //   activePicker: null,
      //   menu: false,
      // },
    ],
    llcAgreementFormValues: {
      authorizedSignerTitle: '',
      authorizedSignerName: '',
      managerMemberName: '',
      managerMemberRole: '',
      resolutionAdoptionDate: '',
      managersAndMembers: [
        {
          name: '',
          role: '',
          managerOrMember: '',
        },
      ],
    },
    corporateAgreementFormValues: {},
    entityDisclosuresFormValues: {
      customerAgreement: false,
      formCRS: false,
      privacyPolicy: false,
    },
    entityOptionMarginValues: {
      optionAgreementAgreed: false,
      marginAgreementAgreed: false,
      uncoveredOptionAgreed: false,
      otcDocDownloaded: false,
    },

    // Retirement forms ---------------------------------
    retirementFormValues: {
      citizenshipCountry: 'USA',
      homeCountry: 'USA',
    },
    iraBeneficiariesFormValues: {
      beneficiaries: [],
    },
    iraOptionMarginValues: {
      marginAgreementAgreed: false,
      optionAgreementAgreed: false,
    },
    // Custodial forms ----------------------------------
    custodialFormValues: {},
    custodianInformationFormValues: {},
    // Trust --------------------------------------------
    trustFormValues: {},
    trusteesFormValues: {
      trustees: [],
    },
    // Used across all-----------------------------------
    optionMarginValues: {
      marginAgreementAgreed: false,
      optionAgreementAgreed: false,
    },
    regulatoryAndDisclosuresValues: {}, //used on every one except business

    // Validations---------------------------------------
    individualFormValidation: false,
    employmentInfoFormValidation: false,
    financialProfileFormValidation: false,
    jointApplicantValidation: false,
    entityFormValidation: false,
    entityOfficersValidation: false,
    beneficialOwnersValidation: false,
    entityOptionMarginValidation: false,
    // llcAgreementValidation: false,
    // these two should be combined to 1 validation
    // corporateAgreementValidation: false,
    agreementValidation: false,
    entityDisclosuresValidation: false,
    retirementFormValidation: false,
    iraBeneficiariesValidation: false,
    custodialFormValidation: false,
    custodianInformationValidation: false,
    trustFormValidation: false,
    trusteesFormValidation: false,
    optionMarginValidation: false,
    iraOptionMarginValidation: false,
    regulatoryAndDisclosuresValidation: false,
  },
  getters: {
    getRegulatoryAndDisclosuresValues: (state) =>
      state.regulatoryAndDisclosuresValues,
    getOptionMarginValues: (state) => state.optionMarginValues,

    getTrustFormValues: (state) => state.trustFormValues,
    getTrusteesFormValues: (state) => state.trusteesFormValues,

    getIndividualFormValues: (state) => state.individualFormValues,
    getEmploymentInfoFormValues: (state) => state.employmentInfoFormValues,
    getFinancialProfileFormValues: (state) => state.financialProfileFormValues,
    getJointApplicantValues: (state) => state.jointApplicantValues,

    getEntityFormValues: (state) => state.entityFormValues,
    getEntityOfficersArray: (state) => state.entityOfficersArray,
    getBeneficialOwnersFormValues: (state) => state.beneficialOwnersFormValues,
    getLlcAgreementFormValues: (state) => state.llcAgreementFormValues,
    getCorporateAgreementFormValues: (state) =>
      state.corporateAgreementFormValues,
    getEntityDisclosuresFormValues: (state) =>
      state.entityDisclosuresFormValues,
    getEntityOptionMarginValues: (state) => state.entityOptionMarginValues,

    getRetirementFormValues: (state) => state.retirementFormValues,
    getIraBeneficiariesFormValues: (state) => state.iraBeneficiariesFormValues,
    getIraOptionMarginValues: (state) => state.iraOptionMarginValues,

    getCustodialFormValues: (state) => state.custodialFormValues,
    getCustodianInformationFormValues: (state) =>
      state.custodianInformationFormValues,

    getIndividualFormValidation: (state) => state.individualFormValidation,
    getEmploymentInfoFormValidation: (state) =>
      state.employmentInfoFormValidation,
    getFinancialProfileFormValidation: (state) =>
      state.financialProfileFormValidation,
    getJointApplicantValidation: (state) => state.jointApplicantValidation,
    getEntityFormValidation: (state) => state.entityFormValidation,
    getEntityOfficersValidation: (state) => state.entityOfficersValidation,
    getBeneficialOwnersValidation: (state) => state.beneficialOwnersValidation,
    getAgreementValidation: (state) => state.agreementValidation,
    getEntityDisclosuresValidation: (state) =>
      state.entityDisclosuresValidation,
    getEntityOptionMarginValidation: (state) =>
      state.entityOptionMarginValidation,
    getRetirementFormValidation: (state) => state.retirementFormValidation,
    getIraBeneficiariesValidation: (state) => state.iraBeneficiariesValidation,
    getIraOptionMarginValidation: (state) => state.iraOptionMarginValidation,
    getCustodialFormValidation: (state) => state.custodialFormValidation,
    getCustodianInformationValidation: (state) =>
      state.custodianInformationValidation,
    getTrustFormValidation: (state) => state.trustFormValidation,
    getTrusteesFormValidation: (state) => state.trusteesFormValidation,
    getOptionMarginValidation: (state) => state.optionMarginValidation,
    getRegulatoryAndDisclosuresValidation: (state) =>
      state.regulatoryAndDisclosuresValidation,
  },
  mutations: {
    // localStorage.setItem( 'setcurrentlySelectedAccountInformation', this.selectedAccountNumber );
    // console.log(localStorage)
    // validation mutations------------------------------------------------------------
    setIndividualFormValidation: (state, payload) => {
      state.individualFormValidation = payload
    },
    setEmploymentInfoFormValidation: (state, payload) => {
      state.employmentInfoFormValidation = payload
    },
    setFinancialProfileFormValidation: (state, payload) => {
      state.financialProfileFormValidation = payload
    },
    setJointApplicantValidation: (state, payload) => {
      state.jointApplicantValidation = payload
    },
    setEntityFormValidation: (state, payload) => {
      state.entityFormValidation = payload
    },
    setEntityOfficersValidation: (state, payload) => {
      state.entityOfficersValidation = payload
    },
    setBeneficialOwnersValidation: (state, payload) => {
      state.beneficialOwnersValidation = payload
    },
    setAgreementValidation: (state, payload) => {
      state.agreementValidation = payload
    },
    setEntityDisclosuresValidation: (state, payload) => {
      state.entityDisclosuresValidation = payload
    },
    setEntityOptionMarginValidation: (state, payload) => {
      state.entityOptionMarginValidation = payload
    },
    setRetirementFormValidation: (state, payload) => {
      state.retirementFormValidation = payload
    },
    setIraBeneficiariesValidation: (state, payload) => {
      state.iraBeneficiariesValidation = payload
    },
    setIraOptionMarginValidation: (state, payload) => {
      state.iraOptionMarginValidation = payload
    },
    setCustodialFormValidation: (state, payload) => {
      state.custodialFormValidation = payload
    },
    setCustodianInformationValidation: (state, payload) => {
      state.custodianInformationValidation = payload
    },
    setTrustFormValidation: (state, payload) => {
      state.trustFormValidation = payload
    },
    setTrusteesFormValidation: (state, payload) => {
      state.trusteesFormValidation = payload
    },
    setOptionMarginValidation: (state, payload) => {
      state.optionMarginValidation = payload
    },
    setRegulatoryAndDisclosuresValidation: (state, payload) => {
      state.regulatoryAndDisclosuresValidation = payload
    },
    // ------------------------------------------------------------
    setCustodianInformationFormValues: (state, payload) => {
      state.custodianInformationFormValues = payload
    },
    setCustodialFormValues: (state, payload) => {
      state.custodialFormValues = payload
    },
    setIraBeneficiariesFormValues: (state, payload) => {
      state.iraBeneficiariesFormValues = payload
    },
    setRetirementFormValues: (state, payload) => {
      state.retirementFormValues = payload
    },
    setEntityDisclosuresFormValues: (state, payload) => {
      state.entityDisclosuresFormValues = payload
    },
    setEntityOptionMarginValues: (state, payload) => {
      state.entityOptionMarginValues = payload
    },
    setCorporateAgreementFormValues: (state, payload) => {
      state.corporateAgreementFormValues = payload
    },
    setBeneficialOwnersFormValues: (state, payload) => {
      state.beneficialOwnersFormValues = payload
    },
    setLlcAgreementFormValues: (state, payload) => {
      state.llcAgreementFormValues = payload
    },
    setTrustFormValues: (state, payload) => {
      state.trustFormValues = payload
    },
    setTrusteesFormValues: (state, payload) => {
      state.trusteesFormValues = payload
    },
    setRegulatoryAndDisclosuresValues: (state, payload) => {
      state.regulatoryAndDisclosuresValues = payload
    },
    resetAllOnboardingState: (state) => {
      // Reset all form values
      state.individualFormValues = {}
      state.employmentInfoFormValues = {}
      state.financialProfileFormValues = {}
      state.jointApplicantValues = {}
      state.entityFormValues = {}
      state.entityOfficersArray = []
      state.beneficialOwnersFormValues = []
      state.llcAgreementFormValues = {}
      state.corporateAgreementFormValues = {}
      state.entityDisclosuresFormValues = {
        customerAgreement: false,
        formCRS: false,
        privacyPolicy: false,
      }
      state.entityOptionMarginValues = {
        optionAgreementAgreed: false,
        marginAgreementAgreed: false,
        uncoveredOptionAgreed: false,
        otcDocDownloaded: false,
      }
      state.retirementFormValues = {
        citizenshipCountry: 'USA',
        homeCountry: 'USA',
      }
      state.iraBeneficiariesFormValues = {
        beneficiaries: [],
      }
      state.iraOptionMarginValues = {
        marginAgreementAgreed: false,
        optionAgreementAgreed: false,
      }
      state.custodialFormValues = {}
      state.custodianInformationFormValues = {}
      state.trustFormValues = {}
      state.trusteesFormValues = {
        trustees: [],
      }
      state.optionMarginValues = {
        marginAgreementAgreed: false,
        optionAgreementAgreed: false,
      }
      state.regulatoryAndDisclosuresValues = {}

      // Reset all validations
      state.individualFormValidation = false
      state.employmentInfoFormValidation = false
      state.financialProfileFormValidation = false
      state.jointApplicantValidation = false
      state.entityFormValidation = false
      state.entityOfficersValidation = false
      state.beneficialOwnersValidation = false
      state.entityOptionMarginValidation = false
      state.agreementValidation = false
      state.entityDisclosuresValidation = false
      state.retirementFormValidation = false
      state.iraBeneficiariesValidation = false
      state.custodialFormValidation = false
      state.custodianInformationValidation = false
      state.trustFormValidation = false
      state.trusteesFormValidation = false
      state.optionMarginValidation = false
      state.iraOptionMarginValidation = false
      state.regulatoryAndDisclosuresValidation = false
    },
    setEntityDisclosuresValues: (state, payload) => {
      state.entityDisclosuresValue = payload
    },
    setOptionMarginValues: (state, payload) => {
      state.optionMarginValues = payload
    },
    setJointApplicantValues: (state, payload) => {
      state.jointApplicantValues = payload
    },
    setIndividualFormValues: (state, payload) => {
      state.individualFormValues = payload
    },
    setEmploymentInfoFormValues: (state, payload) => {
      state.employmentInfoFormValues = payload
    },
    setFinancialProfileFormValues: (state, payload) => {
      state.financialProfileFormValues = payload
    },
    setEntityFormValues: (state, payload) => {
      state.entityFormValues = payload
    },
    setEntityOfficersArray: (state, payload) => {
      state.entityOfficersArray = payload
    },
    setIraOptionMarginValues: (state, payload) => {
      state.iraOptionMarginValues = payload
    },
  },
}
